import { CalendarService } from './services/calendar/calendar.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { DocumentService } from './services/document/document.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { AccountHomeButtonComponent } from './components/account-home-button/account-home-button.component';
import { AccountRouting } from './account-routing';
import { AccountConfigService, AccountConfigServiceOption } from './services/account-config/account-config.service';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { CommonModule } from '@angular/common';
import { CartModule } from '../cart/cart.module';
import { CaCardComponent } from './components/static/static-card/ca-card/ca-card.component';
import { DevisListComponent } from './components/devis-list/devis-list.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { FactureListComponent } from './components/facture-list/facture-list.component';
import { GlobalModule } from '@argalis-apps/angular-global';
import { MargeCardComponent } from './components/static/static-card/marge-card/marge-card.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SessionDocumentComponent } from './components/session/session-document/session-document.component';
import { SessionApprenantComponent } from './components/session/session-apprenant/session-apprenant.component';
import { SessionCarteAchatComponent } from './components/session/session-carte-achat/session-carte-achat.component';
import { SessionInformationComponent } from './components/session/session-information/session-information.component';
import { RouterModule, Routes } from '@angular/router';
import { SessionListComponent } from './components/session/session-list/session-list.component';
import { SessionPlanningComponent } from './components/session/session-planning/session-planning.component';
import { SessionSousTitreComponent } from './components/session/session-sous-titre/session-sous-titre.component';
import { StatisfactionCardComponent } from './components/static/static-card/statisfaction-card/statisfaction-card.component';
import { StagiareCardComponent } from './components/static/static-card/stagiare-card/stagiare-card.component';
import { SessionCardComponent } from './components/static/static-card/session-card/session-card.component';
import { SessionViewComponent } from './components/session/session-view/session-view.component';
import { StaticListCardComponent } from './components/static/static-card-list/static-list-card.component';
import { SatisfactionFormComponent } from './components/satisfaction-form/satisfaction-form.component';
import { ProfileButtonComponent } from './components/profile/profile-button/profile-button.component';
import { AccountService } from './services/account/account.service';
import { ProfileInformationsComponent } from './components/profile-informations/profile-informations.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DevisService } from './services/devis/devis.service';
import { FactureService } from './services/facture/facture.service';
import { GridModule } from '@progress/kendo-angular-grid';
import { InterCardsComponent } from './components/static/static-card/inter-cards/inter-cards.component';
import { FormationComponent } from './components/formation/formation.component';
import { SessionEvaluationComponent } from './components/session/session-evaluation/session-evaluation.component';
import { SessionPresenceComponent } from './components/session/session-presence/session-presence.component';
import { PopupPresenceComponent } from './components/session/session-presence/popup-presence/popup-presence.component';
import { SessionRapportIntervenantComponent } from './components/session/session-rapport-intervenant/session-rapport-intervenant.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ShortcutButtonComponent } from './components/dashboard/shortcut-button/shortcut-button.component';
import { ClockComponent } from './components/dashboard/clock/clock.component';
import { ActivityCardComponent } from './components/dashboard/activity-card/activity-card.component';
import { NextTaskComponent } from './components/dashboard/next-task/next-task.component';
import { DashboardService } from './services/dashboard/dashboard.service';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MenuModule } from '@progress/kendo-angular-menu';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { SessionHabilitationComponent } from './components/session/session-habilitation/session-habilitation.component';
import { FicheFormationComponent } from './components/formation/fiche-formation/fiche-formation.component';
import { FormationInfoComponent } from './components/formation/fiche-formation/formation-info/formation-info.component';
import { FormationPlanningComponent } from './components/formation/fiche-formation/formation-planning/formation-planning.component';
import { FormationApprenantComponent } from './components/formation/fiche-formation/formation-apprenant/formation-apprenant.component';
import { FormationDocComponent } from './components/formation/fiche-formation/formation-doc/formation-doc.component';
import { FormationListComponent } from './components/formation/formation-list/formation-list.component';
import { DemandesEncadrementListComponent } from './components/demandes-encadrement-list/demandes-encadrement-list.component';
import { DemandeEncadrementService } from './services/demande-encadrement/demande-encadrement.service';
import { DemandesEncadrementDetailsComponent } from './components/demandes-encadrement-details/demandes-encadrement-details.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { PlanningComponent } from './components/calendar/planning/planning.component';
import { BlocInfoComponent } from './components/calendar/bloc-info/bloc-info.component';
import { HeaderCalendarComponent } from './components/calendar/header-calendar/header-calendar.component';
import { InfoSessionComponent } from './components/calendar/bloc-info/info-session/info-session.component';
import { InfoIndispoComponent } from './components/calendar/bloc-info/info-indispo/info-indispo.component';
import { InfoEncadrementComponent } from './components/calendar/bloc-info/info-encadrement/info-encadrement.component';
import { AuthService } from '../auth/services/auth/auth.service';
import { SessionConsigneComponent } from './components/session/session-consigne/session-consigne.component';
import { SelectorService } from './services/selector/selector.service';
import { EditorModule } from '@progress/kendo-angular-editor';
import { FooterCalendarComponent } from './components/calendar/footer-calendar/footer-calendar.component';
import { SessionPrerequisComponent } from './components/session/session-prerequis/session-prerequis.component';
import { DocumentManagementComponent } from './components/document/document-management/document-management.component';
import { HabilitationElectriqueComponent } from './components/session/session-habilitation/habilitation-electrique/habilitation-electrique.component';
import { HabilitationCacesAcComponent } from './components/session/session-habilitation/habilitation-caces-ac/habilitation-caces-ac.component';
import { PopupHabilitationCacesAcComponent } from './components/session/session-habilitation/habilitation-caces-ac/popup-habilitation-caces-ac/popup-habilitation-caces-ac.component';
import { FloatingLabelModule } from "@progress/kendo-angular-label";
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { LabelModule } from "@progress/kendo-angular-label";

const staticComponents = [
  StaticListCardComponent,
  MargeCardComponent,
  CaCardComponent,
  SessionCardComponent,
  StatisfactionCardComponent,
  StagiareCardComponent,
  InterCardsComponent
];
export const formationCompenents = [
  FormationInfoComponent,
  FormationPlanningComponent,
  FormationApprenantComponent,
  FormationDocComponent,
  FormationListComponent,
  FicheFormationComponent
];
export const sessionComponents = [
  SessionRapportIntervenantComponent,
  SessionHabilitationComponent,
  SessionConsigneComponent,
  SessionApprenantComponent,
  SessionCarteAchatComponent,
  SessionDocumentComponent,
  SessionInformationComponent,
  SessionListComponent,
  SessionPlanningComponent,
  SessionSousTitreComponent,
  SessionViewComponent,
  SessionEvaluationComponent,
  SessionPresenceComponent,
  SessionRapportIntervenantComponent,
  SessionHabilitationComponent,
  SessionViewComponent,
  InfoSessionComponent
];
@NgModule({
  declarations: [
    AccountHomeButtonComponent,
    CalendarComponent,
    DevisListComponent,
    DemandesEncadrementListComponent,
    DemandesEncadrementDetailsComponent,
    FactureListComponent,
    ProfileComponent,
    formationCompenents,
    ProfileButtonComponent,
    ProfileInformationsComponent,
    ProfileButtonComponent,
    staticComponents,
    sessionComponents,
    SatisfactionFormComponent,
    FormationComponent,
    DashboardComponent,
    ShortcutButtonComponent,
    ClockComponent,
    ActivityCardComponent,
    NextTaskComponent,
    FormationComponent,
    SessionEvaluationComponent,
    SessionPresenceComponent,
    PopupPresenceComponent,
    DemandesEncadrementListComponent,
    DemandesEncadrementDetailsComponent,
    CalendarComponent,
    PlanningComponent,
    BlocInfoComponent,
    HeaderCalendarComponent,
    InfoIndispoComponent,
    InfoEncadrementComponent,
    FooterCalendarComponent,
    SessionPrerequisComponent,
    DocumentManagementComponent,
    HabilitationElectriqueComponent,
    HabilitationCacesAcComponent,
    PopupHabilitationCacesAcComponent
  ],
  imports: [
    DialogsModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    CartModule,
    CommonModule,
    DropDownsModule,
    GlobalModule,
    InputsModule,
    RouterModule,
    DateInputsModule,
    DialogModule,
    GridModule,
    LayoutModule,
    MenuModule,
    TreeViewModule,
    SchedulerModule,
    BrowserModule,
    BrowserAnimationsModule,
    EditorModule,
    FloatingLabelModule,
    LabelModule,
  ],
  exports: [
    AccountHomeButtonComponent,
    DevisListComponent,
    DemandesEncadrementListComponent,
    DemandesEncadrementDetailsComponent,
    FactureListComponent,
    sessionComponents,
    SatisfactionFormComponent,
    staticComponents,
    CalendarComponent,
    DashboardComponent,
    ShortcutButtonComponent,
    ActivityCardComponent,
    staticComponents,
    FloatingLabelModule
  ],
  providers: [
    AccountConfigService,
    AccountService,
    DemandeEncadrementService,
    DevisService,
    AuthService,
    FactureService,
    CalendarService,
    SelectorService,
    DocumentService,
    DashboardService
  ]
})
export class AccountModule {
  public static moduleRouting(config?: AccountConfigServiceOption): Routes {
    return AccountRouting;
  }

  public static forRoot(config?: AccountConfigServiceOption): ModuleWithProviders<AccountModule> {
    return {
      ngModule: AccountModule,
      providers: [
        AccountConfigService,
        AccountService,
        DemandeEncadrementService,
        DevisService,
        FactureService,
        DocumentService,
        {
          provide: AccountConfigServiceOption,
          useValue: config
        }
      ]
    };
  }
}
